import { render, staticRenderFns } from "./StudioNonMediaDetailsSidebar.vue?vue&type=template&id=e392c6d2&scoped=true&"
import script from "./StudioNonMediaDetailsSidebar.vue?vue&type=script&lang=ts&"
export * from "./StudioNonMediaDetailsSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./StudioNonMediaDetailsSidebar.vue?vue&type=style&index=0&id=e392c6d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e392c6d2",
  null
  
)

export default component.exports